import { render, staticRenderFns } from "./products-search-bar.vue?vue&type=template&id=3c8f8680&"
import script from "./products-search-bar.vue?vue&type=script&lang=js&"
export * from "./products-search-bar.vue?vue&type=script&lang=js&"
import style0 from "./products-search-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports